<template>
  <v-dialog v-model="dialog" persistent max-width="1200px">
    <v-card>
      <v-card-title class="dialog-title">
        <div>
          <div class="text-h6">
            Detalles ODT {{ claveLabel }}
          </div>
          <div class="caption grey--text text--darken-1">
            {{ descripcionLabel }}
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip small :color="isParoView ? 'blue-grey darken-1' : (isDelayView ? 'amber darken-2' : estadoColor)" dark>
          {{ isParoView ? "Paro" : (isDelayView ? "Atraso" : estadoLabel) }}
        </v-chip>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <div class="field">
                <div class="field-label">Clave ODT</div>
                <div class="field-value">{{ claveLabel }}</div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <div class="field">
                <div class="field-label">Articulo</div>
                <div class="field-value">{{ odtSafe.codigoArticulo || odtSafe.articulo || "N/D" }}</div>
              </div>
            </v-col>
            <v-col v-if="!isParoView && !isDelayView" cols="12" sm="6" md="3">
              <div class="field">
                <div class="field-label">Fin Teorico</div>
                <div class="field-value">{{ formatDate(odtSafe.fechaFinTeorica) }}</div>
              </div>
            </v-col>
            <v-col :cols="12" :sm="6" :md="(isParoView || isDelayView) ? 6 : 3">
              <div class="field">
                <div class="field-label">Rango</div>
                <div class="field-value">{{ formatDate(odtSafe.fechaInicioProduccion) }} - {{
                  formatDate(odtSafe.fechaEntrega) }}</div>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="!isRealView" dense class="mt-2">
            <v-col cols="12">
              <div class="field">
                <div class="field-label">Maquinas Disponibles</div>
                <div class="field-value">{{ maquinasDisponiblesLabel }}</div>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="isRealView" dense class="mt-2">
            <v-col cols="12" sm="6" md="4">
              <div class="field">
                <div class="field-label">Area</div>
                <div class="field-value">{{ realAreaLabel }}</div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" :md="isParoView ? 8 : 4">
              <div class="field">
                <div class="field-label">Maquina Asignada</div>
                <div class="field-value">{{ realMachineLabel }}</div>
              </div>
            </v-col>
            <v-col v-if="!isParoView && !isDelayView" cols="12" sm="6" md="4">
              <div class="field">
                <div class="field-label">Tiempo Real</div>
                <div class="field-value">{{ formatDuration(realDurationSeg) }}</div>
              </div>
            </v-col>
            <v-col v-if="!isParoView && !isDelayView" cols="12" sm="6" md="6">
              <div class="field">
                <div class="field-label">Operador</div>
                <div class="field-value">{{ realOperatorLabel }}</div>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="isRealView && !isParoView" dense class="mt-2">
            <v-col cols="12" md="6">
              <div class="field">
                <div class="field-label">Subpasos Pendientes</div>
                <div class="field-value field-value--list">
                  <div v-if="realPendingSubsteps.length" class="subpasos-list">
                    <div v-for="(subpaso, idx) in realPendingSubsteps" :key="`pend-${idx}`" class="subpaso-item">
                      {{ formatSubpaso(subpaso, idx) }}
                    </div>
                  </div>
                  <span v-else>N/D</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="field">
                <div class="field-label">Subpasos En Progreso</div>
                <div class="field-value field-value--list">
                  <div v-if="realInProgressSubsteps.length" class="subpasos-list">
                    <div v-for="(subpaso, idx) in realInProgressSubsteps" :key="`prog-${idx}`" class="subpaso-item">
                      {{ formatSubpaso(subpaso, idx) }}
                    </div>
                  </div>
                  <span v-else>N/D</span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row dense class="mt-4">
            <v-col cols="12">
              <v-card outlined class="subcard">
                <v-card-title class="subtitle-2">Operaciones</v-card-title>
                <div v-if="selectedFragmentLabel && false" class="fragmento-selected-label">
                  {{ selectedFragmentLabel }}
                </div>
                <v-data-table :headers="currentOperationHeaders" :items="operaciones" :item-class="operationRowClass" dense
                  disable-pagination hide-default-footer>
                  <template v-slot:item.estado="{ item }">
                    <v-chip x-small :color="estadoOperacionColor(item.estado)" dark>
                      {{ estadoOperacionLabel(item.estado, item.estadoTexto) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.duracionSeg="{ item }">
                    {{ formatDuration(item.duracionSeg) }}
                  </template>
                  <template v-slot:item.esTeorica="{ item }">
                    {{ item.esTeorica ? "Si" : "No" }}
                  </template>
                  <template v-slot:item.paroDetalle="{ item }">
                    {{ item.paroDetalle || "-" }}
                  </template>
                  <template v-slot:item.subpasos="{ item }">
                    <div v-if="Array.isArray(item.subpasos) && item.subpasos.length" class="subpasos-list">
                      <div v-for="(subpaso, idx) in item.subpasos" :key="`subpaso-${idx}`" class="subpaso-item">
                        {{ formatSubpaso(subpaso, idx) }}
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense class="mt-4" v-if="false">
            <v-col cols="12">
              <v-card outlined class="subcard">
                <v-card-title class="subtitle-2">Ingredientes Involucrados</v-card-title>
                <v-data-table :headers="ingredienteHeaders" :items="ingredientes" dense disable-pagination
                  hide-default-footer></v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogDetallesOdt",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    odt: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: this.value,
      localOdt: {},
      ingredienteHeaders: [
        { text: "Paso", value: "paso" },
        { text: "Area", value: "area" },
        { text: "Tipo", value: "tipo" },
        { text: "Ingrediente", value: "ingrediente" },
        { text: "Codigo", value: "codigoArticulo" },
        { text: "Cantidad", value: "cantidad" },
        { text: "Unidad", value: "unidad" },
        { text: "Tiempo", value: "tiempoSeg" },
      ],
    };
  },
  computed: {
    odtSafe() {
      return this.localOdt || {};
    },
    claveLabel() {
      return this.odtSafe.clave || this.odtSafe.ot || "N/D";
    },
    descripcionLabel() {
      return this.odtSafe.descripcion || this.odtSafe.articulo || "Sin descripcion";
    },
    maquinasDisponiblesLabel() {
      const values = Array.isArray(this.odtSafe.maquinasDisponibles) ? this.odtSafe.maquinasDisponibles : [];
      return values.length
        ? values.map((item, idx) => `${idx + 1}. ${item}`).join(" | ")
        : "Por Asignar";
    },
    isRealView() {
      return this.odtSafe.planView === "real" || this.operacionesRaw.some((item) => item && item.esTeorica === false);
    },
    isParoView() {
      return this.isRealView && !!this.selectedParoId;
    },
    isDelayView() {
      return this.isRealView && (
        !!this.odtSafe.selectedDelay
        || this.operacionesRaw.some((item) => item && item.estadoId === 5)
        || this.operacionesRaw.some((item) => ["retraso", "atraso"].includes(String(item && item.estado).toLowerCase()))
      );
    },
    operacionLabel() {
      if (!this.isRealView && this.odtSafe.idOperacion != null) return this.odtSafe.idOperacion;
      return `${this.operacionesRaw.length || 0} op(s)`;
    },
    currentOperationHeaders() {
      if (this.isRealView) {
        if (this.selectedParoId) {
          return [
            { text: "Area", value: "area" },
            { text: "Inicio Paro", value: "inicio", width: "170px" },
            { text: "Fin Paro", value: "fin", width: "170px" },
            { text: "Motivo", value: "motivo" },
            { text: "Duracion", value: "duracionParoTexto" },
            { text: "Piezas No OK", value: "cantidadNoOk" },
          ];
        }
        if (this.isDelayView) {
          return [
            { text: "Area", value: "area" },
            { text: "Inicio", value: "inicio", width: "170px" },
            { text: "Fin", value: "fin", width: "170px" },
            { text: "Duracion", value: "duracionRealTexto" },
          ];
        }
        return [
          { text: "Area", value: "area" },
          { text: "Inicio", value: "inicio", width: "170px" },
          { text: "Fin", value: "fin", width: "170px" },
          { text: "Duracion", value: "duracionRealTexto" },
          { text: "Piezas Planeadas", value: "piezasPlaneadas" },
          { text: "Piezas Reportadas", value: "piezasReportadasTotal" },
          { text: "Diferencia", value: "diferenciaPiezas" },
        ];
      }
      return [
        { text: "Estado", value: "estado" },
        { text: "Area", value: "area" },
        { text: "Inicio", value: "inicio", width: "170px" },
        { text: "Fin", value: "fin", width: "170px" },
        // { text: "Hora Inicio", value: "horaInicio" },
        // { text: "Hora Fin", value: "horaFin" },
        { text: "Subpasos", value: "subpasos", sortable: false },
        { text: "Tiempo ciclo", value: "tiempoCicloSegundos" },
        { text: "Duracion", value: "duracionTeoricaTexto" },
        { text: "Piezas Planeadas", value: "piezasPlaneadas" },
        { text: "Teorica", value: "esTeorica" },
      ];
    },
    realAreaLabel() {
      const value = this.mergeDistinctLabels(this.operacionesRaw.map((item) => item && item.area));
      return value || "N/D";
    },
    realMachineLabel() {
      const value = this.mergeDistinctLabels(this.operacionesRaw.map((item) => item && item.maquinaAsignada));
      return value || "N/D";
    },
    realOperatorLabel() {
      const value = this.mergeDistinctLabels(
        this.operacionesRaw.flatMap((item) => (Array.isArray(item && item.operarios) ? item.operarios : []))
      );
      return value || "N/D";
    },
    realPendingSubsteps() {
      return this.mergeSubstepObjects(
        this.operacionesRaw.flatMap((item) => (Array.isArray(item && item.subpasosPendientes) ? item.subpasosPendientes : []))
      );
    },
    realInProgressSubsteps() {
      return this.mergeSubstepObjects(
        this.operacionesRaw.flatMap((item) => (Array.isArray(item && item.subpasosEnProceso) ? item.subpasosEnProceso : []))
      );
    },
    realPlannedPieces() {
      return this.operacionesRaw.reduce((acc, op) => {
        const value = Number(op && op.piezasPlaneadas);
        return Number.isFinite(value) ? acc + value : acc;
      }, 0);
    },
    realReportedPieces() {
      return this.operacionesRaw.reduce((acc, op) => {
        const value = Number(op && op.piezasReportadasTotal);
        return Number.isFinite(value) ? acc + value : acc;
      }, 0);
    },
    realDifference() {
      return this.realPlannedPieces - this.realReportedPieces;
    },
    realDurationSeg() {
      return this.operacionesRaw.reduce((acc, op) => {
        const value = Number(op && op.duracionSeg);
        return Number.isFinite(value) ? acc + value : acc;
      }, 0);
    },
    realPlannedPiecesLabel() {
      return this.formatNumber(this.realPlannedPieces);
    },
    realReportedPiecesLabel() {
      return this.formatNumber(this.realReportedPieces);
    },
    realDifferenceLabel() {
      return this.formatNumber(this.realDifference);
    },
    realDifferenceClass() {
      if (this.realDifference > 0) return "error--text";
      if (this.realDifference < 0) return "success--text";
      return "";
    },
    porcentajeValue() {
      const value = Number(this.odtSafe.porcentajeCompletado ?? this.odtSafe.porcentajeAvance ?? 0);
      return Number.isFinite(value) ? value : 0;
    },
    porcentajeLabel() {
      return `${this.porcentajeValue.toFixed(2)} %`;
    },
    estadoLabel() {
      const estado = Number(this.odtSafe.estadoProduccion ?? 0);
      return this.estadoToLabel(estado);
    },
    estadoColor() {
      const estado = Number(this.odtSafe.estadoProduccion ?? 0);
      return this.estadoToColor(estado);
    },
    operacionesRaw() {
      const ops = this.odtSafe.operaciones || this.odtSafe.areas || [];
      return Array.isArray(ops) ? ops : [];
    },
    selectedFragmentNumber() {
      const number = Number(this.odtSafe.fragmentoSeleccionado);
      return Number.isFinite(number) && number > 0 ? number : null;
    },
    selectedParoId() {
      const number = Number(this.odtSafe.selectedParoId);
      return Number.isFinite(number) && number > 0 ? number : null;
    },
    selectedOperationId() {
      const number = Number(this.odtSafe.selectedOperationId);
      return Number.isFinite(number) && number > 0 ? number : null;
    },
    operaciones() {
      if (this.isRealView) {
        if (this.selectedParoId) {
          let rows = this.operacionesRaw
            .flatMap((op) => {
              const paros = Array.isArray(op && op.paros) ? op.paros : [];
              return paros.map((paro, idx) => ({
                fragmentoNumero: idx + 1,
                idOperacion: op && op.idOperacion != null ? op.idOperacion : null,
                area: op && op.area ? op.area : "N/D",
                inicio: this.formatDate(paro && paro.inicio),
                fin: this.formatDate(paro && paro.fin),
                horaInicio: this.normalizeHour(paro && paro.inicio),
                horaFin: this.normalizeHour(paro && paro.fin),
                motivo: paro && paro.concepto ? paro.concepto : "N/D",
                estado: 2,
                estadoTexto: "Paro",
                duracionSeg: Number(paro && paro.duracionSegundos) || 0,
                duracionParoTexto: this.formatDurationHoursMinutes(paro && paro.duracionSegundos),
                conceptoParo: paro && paro.concepto ? paro.concepto : "N/D",
                cantidadNoOk: paro && paro.cantidadNoOk != null ? paro.cantidadNoOk : null,
                idParo: paro && paro.idParo != null ? paro.idParo : null,
                paroDetalle: this.buildParoDetalle(paro),
              }));
            })
            .sort((a, b) => String(a.inicio || "").localeCompare(String(b.inicio || "")));
          rows = rows.filter((item) => Number(item.idParo) === this.selectedParoId);
          return rows;
        }

        let rows = this.operacionesRaw
          .map((op, idx) => ({
            fragmentoNumero: Number(op.fragmentoNumero) || (idx + 1),
            idOperacion: op && op.idOperacion != null ? op.idOperacion : null,
            area: op && op.area ? op.area : "N/D",
            inicio: this.formatDate(op && (op.inicioReal || op.inicio || op.fechaInicio)),
            fin: this.isDelayView
              ? "N/D"
              : this.formatDate(op && (op.finReal || op.fin || op.fechaFin)),
            horaInicio: this.normalizeHour(op && (op.inicioReal || op.inicio || op.fechaInicio)),
            horaFin: this.isDelayView
              ? "--:--"
              : this.normalizeHour(op && (op.finReal || op.fin || op.fechaFin)),
            estado: op
              ? (op.estadoId ?? op.estado ?? op.estadoProduccion ?? 4)
              : 4,
            estadoTexto: op
              ? (op.estadoTexto || (typeof op.estado === "string" ? op.estado : "") || "Produccion")
              : "Produccion",
            duracionSeg: Number(op && op.duracionSeg) || 0,
            duracionRealTexto: this.formatDurationHoursMinutes(op && op.duracionSeg),
            piezasPlaneadas: op && op.piezasPlaneadas != null ? op.piezasPlaneadas : null,
            piezasReportadasTotal: op && op.piezasReportadasTotal != null ? op.piezasReportadasTotal : null,
            diferenciaPiezas: op && op.diferenciaPiezas != null ? op.diferenciaPiezas : null,
          }))
          .sort((a, b) => String(a.inicio || "").localeCompare(String(b.inicio || "")));
        if (this.selectedOperationId) {
          rows = rows.filter((item) => Number(item.idOperacion) === this.selectedOperationId);
        }
        return rows;
      }
      const rows = this.operacionesRaw
        .slice()
        .sort((a, b) => String(a.inicio || "").localeCompare(String(b.inicio || "")));
      return rows.map((op, idx) => ({
        fragmentoNumero: Number(op.fragmentoNumero) || (idx + 1),
        //idOperacion: op.idOperacion ?? op.operacion ?? "N/D",
        area: op.area || "N/D",
        inicio: this.formatDate(op.inicio || op.fechaInicio || this.odtSafe.fechaInicioProduccion),
        fin: this.formatDate(op.fechaEntrega || this.odtSafe.fechaEntrega || op.fin || op.fechaFin),
        horaInicio: this.normalizeHour(op.horaInicio || op.inicio || op.fechaInicio),
        horaFin: this.normalizeHour(op.horaFin || op.fin || op.fechaFin),
        estado: op.estadoId ?? op.estado ?? op.estadoProduccion ?? 0,
        estadoTexto: op.estadoTexto || (typeof op.estado === "string" ? op.estado : ""),
        duracionSeg: Number(op.duracionSeg ?? 0) || 0,
        duracionTeoricaTexto: this.formatDurationDaysHoursMinutes(op.duracionSeg),
        subpasos: Array.isArray(op.subpasos) ? op.subpasos : [],
        tiempoCicloSegundos: op.tiempoCicloSegundos ?? null,
        cantidad: op.cantidad ?? null,
        piezasPlaneadas: op.piezasPlaneadas ?? null,
        piezasReportadasTotal: op.piezasReportadasTotal ?? null,
        diferenciaPiezas: op.diferenciaPiezas ?? null,
        cantidadHechaTotal: op.cantidadHechaTotal ?? null,
        cantidadNoOk: op.cantidadNoOk ?? null,
        cantidadScrap: op.cantidadScrap ?? null,
        cantidadRetrabajo: op.cantidadRetrabajo ?? null,
        esTeorica: !!op.esTeorica,
        idParo: op.idParo ?? null,
        idOperacionReal: op.idOperacionReal ?? null,
        paroDetalle: this.buildParoDetalle(op),
      }));
    },
    selectedFragment() {
      if (!this.selectedFragmentNumber) return null;
      return this.operaciones.find((item) => Number(item.fragmentoNumero) === this.selectedFragmentNumber) || null;
    },
    selectedFragmentLabel() {
      if (!this.selectedFragment) return "";
      const item = this.selectedFragment;
      const estado = this.estadoOperacionLabel(item.estado, item.estadoTexto);
      return `Fragmento ${item.fragmentoNumero}: ${estado} (${item.horaInicio} - ${item.horaFin})`;
    },
    desfaseSeg() {
      const direct = Number(this.odtSafe.desfaseSeg);
      if (Number.isFinite(direct)) return direct;
      return this.operacionesRaw.reduce((acc, op) => {
        const estado = Number(op.estado ?? op.estadoProduccion ?? 0);
        const duracion = Number(op.duracionSeg ?? 0);
        if (estado !== 5 || !Number.isFinite(duracion)) return acc;
        return acc + duracion;
      }, 0);
    },
    diferenciaSeg() {
      const direct = Number(this.odtSafe.diferenciaSeg);
      if (Number.isFinite(direct)) return direct;
      const total = this.operacionesRaw.reduce((acc, op) => {
        const duracion = Number(op.duracionSeg ?? 0);
        return Number.isFinite(duracion) ? acc + duracion : acc;
      }, 0);
      const teorico = this.operacionesRaw.reduce((acc, op) => {
        const duracion = Number(op.duracionSeg ?? 0);
        const esTeorica = Boolean(op.esTeorica);
        return esTeorica && Number.isFinite(duracion) ? acc + duracion : acc;
      }, 0);
      return total - teorico;
    },
    desfaseLabel() {
      return this.formatDuration(this.desfaseSeg);
    },
    diferenciaLabel() {
      return this.formatDuration(this.diferenciaSeg, true);
    },
    diferenciaClass() {
      if (this.diferenciaSeg > 0) return "error--text";
      if (this.diferenciaSeg < 0) return "success--text";
      return "";
    },
    ingredientes() {
      const items = this.odtSafe.ingredientes;
      if (!Array.isArray(items)) return [];
      return items.map((item) => ({
        paso: item.paso ?? "-",
        area: item.area || "N/D",
        tipo: item.tipo || "N/D",
        ingrediente: item.ingrediente || "N/D",
        codigoArticulo: item.codigoArticulo || "-",
        cantidad: item.cantidad ?? null,
        unidad: item.unidad || "-",
        tiempoSeg: item.tiempoSeg ?? null,
      }));
    },
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.localOdt = { ...this.odt };
      }
    },
    odt: {
      handler(val) {
        if (val) this.localOdt = { ...val };
      },
      deep: true,
    },
    dialog(val) {
      this.$emit("input", val);
      if (!val) this.$emit("close");
    },
  },
  methods: {
    show(odt) {
      this.localOdt = odt ? { ...odt } : {};
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    operationRowClass(item) {
      if (!item || !this.selectedFragmentNumber) return "";
      return Number(item.fragmentoNumero) === this.selectedFragmentNumber ? "fragment-selected" : "";
    },
    extractTime(value) {
      if (!value && value !== 0) return "";
      let raw = String(value).trim();
      if (!raw) return "";
      if (raw.includes("T")) raw = raw.split("T")[1];
      if (raw.includes(" ")) {
        const pieces = raw.split(" ");
        raw = pieces[pieces.length - 1];
      }
      if (raw.includes(".")) raw = raw.split(".")[0];
      if (raw.endsWith("Z")) raw = raw.slice(0, -1);
      return raw;
    },
    normalizeHour(value) {
      const time = this.extractTime(value);
      if (!time) return "--:--";
      const pieces = time.split(":");
      const hh = String(parseInt(pieces[0], 10) || 0).padStart(2, "0");
      const mm = String(parseInt(pieces[1], 10) || 0).padStart(2, "0");
      return `${hh}:${mm}`;
    },
    formatDate(value) {
      if (!value) return "N/D";
      if (typeof value === "string") {
        return value.length >= 16 ? value.slice(0, 16).replace("T", " ") : value;
      }
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const y = value.getFullYear();
        const m = String(value.getMonth() + 1).padStart(2, "0");
        const d = String(value.getDate()).padStart(2, "0");
        const hh = String(value.getHours()).padStart(2, "0");
        const mm = String(value.getMinutes()).padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}`;
      }
      return String(value);
    },
    formatSubpaso(value, idx) {
      if (!value || typeof value !== "object") return `${idx + 1}. N/D`;
      const codigo = value.codigo ? String(value.codigo).trim() : "";
      const descripcion = value.descripcion ? String(value.descripcion).trim() : "";
      if (codigo && descripcion) return `${codigo} - ${descripcion}`;
      return codigo || descripcion || `${idx + 1}. N/D`;
    },
    mergeSubstepObjects(items) {
      const source = Array.isArray(items) ? items : [];
      const seen = [];
      source.forEach((item) => {
        if (!item || typeof item !== "object") return;
        const key = item.idSubpaso != null
          ? `ID-${item.idSubpaso}`
          : `${item.codigo || ""}|${item.descripcion || ""}|${item.posicion || ""}`;
        if (!seen.some((entry) => entry.key === key)) {
          seen.push({ key, value: item });
        }
      });
      return seen
        .map((entry) => entry.value)
        .sort((a, b) => {
          const left = Number(a && a.posicion);
          const right = Number(b && b.posicion);
          if (Number.isFinite(left) && Number.isFinite(right)) return left - right;
          return this.formatSubpaso(a, 0).localeCompare(this.formatSubpaso(b, 0));
        });
    },
    currency(value) {
      const number = Number(value);
      if (!Number.isFinite(number)) return "$ 0.00";
      return `$ ${number.toFixed(2)}`;
    },
    formatDuration(value, withSign = false) {
      const seconds = Number(value);
      if (!Number.isFinite(seconds)) return "00:00:00";
      const sign = seconds < 0 ? "-" : (withSign && seconds > 0 ? "+" : "");
      const absolute = Math.abs(Math.round(seconds));
      const hh = String(Math.floor(absolute / 3600)).padStart(2, "0");
      const mm = String(Math.floor((absolute % 3600) / 60)).padStart(2, "0");
      const ss = String(absolute % 60).padStart(2, "0");
      return `${sign}${hh}:${mm}:${ss}`;
    },
    formatDurationHoursMinutes(value) {
      const seconds = Number(value);
      if (!Number.isFinite(seconds)) return "00:00";
      const absolute = Math.abs(Math.round(seconds));
      const hh = String(Math.floor(absolute / 3600)).padStart(2, "0");
      const mm = String(Math.floor((absolute % 3600) / 60)).padStart(2, "0");
      return `${hh}:${mm}`;
    },
    formatDurationDaysHoursMinutes(value) {
      const seconds = Number(value);
      if (!Number.isFinite(seconds)) return "00: 00";
      const absolute = Math.abs(Math.round(seconds));
      const totalMinutes = Math.floor(absolute / 60);
      const days = Math.floor(totalMinutes / (24 * 60));
      const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
      const minutes = totalMinutes % 60;
      const hh = String(hours).padStart(2, "0");
      const mm = String(minutes).padStart(2, "0");
      if (days > 0) {
        return `${String(days).padStart(2, "0")}: ${hh}: ${mm}`;
      }
      return `${hh}: ${mm}`;
    },
    formatNumber(value) {
      const number = Number(value);
      if (!Number.isFinite(number)) return "0";
      return `${number}`;
    },
    mergeDistinctLabels(values) {
      const unique = [];
      (Array.isArray(values) ? values : []).forEach((item) => {
        if (typeof item !== "string" || !item.trim()) return;
        item.split(",").forEach((part) => {
          const clean = part.trim();
          if (clean && !unique.includes(clean)) unique.push(clean);
        });
      });
      return unique.join(", ");
    },
    buildParoDetalle(op) {
      const tipo = op && op.paroTipo ? op.paroTipo : "";
      const subtipo = op && op.subParoTipo ? op.subParoTipo : "";
      if (tipo && subtipo) return `${tipo} / ${subtipo}`;
      if (tipo) return tipo;
      if (subtipo) return subtipo;
      return "";
    },
    estadoToLabel(estado) {
      switch (Number(estado)) {
        case 1:
          return "CambioMolde";
        case 2:
          return "ParoProgramado";
        case 3:
          return "ParoNoProgramado";
        case 4:
          return "Produccion";
        case 5:
          return "Atraso";
        case 6:
          return "Muerto";
        case 7:
          return "Retrabajo";
        default:
          return "No Iniciado";
      }
    },
    estadoToColor(estado) {
      switch (Number(estado)) {
        case 1:
          return "amber darken-2";
        case 2:
          return "blue-grey darken-1";
        case 3:
          return "grey darken-3";
        case 4:
          return "green";
        case 5:
          return "blue";
        case 6:
          return "brown";
        case 7:
          return "deep-orange";
        default:
          return "grey";
      }
    },
    estadoOperacionLabel(estado, estadoTexto) {
      if (estadoTexto) return estadoTexto;
      return this.estadoToLabel(estado);
    },
    estadoOperacionColor(estado) {
      const numeric = Number(estado);
      if (!Number.isFinite(numeric) && typeof estado === "string") {
        const text = estado.toLowerCase();
        if (text.includes("produ")) return "green";
        if (text.includes("retra")) return "blue";
        if (text.includes("paro")) return "grey darken-2";
        if (text.includes("muerto")) return "brown";
        if (text.includes("molde")) return "amber darken-2";
        if (text.includes("retrab")) return "deep-orange";
      }
      return this.estadoToColor(numeric);
    },
  },
};
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.field {
  border: 1px solid #e0e6ef;
  border-radius: 6px;
  padding: 10px 12px;
  background-color: #fafbfc;
}

.field-label {
  font-size: 10px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.field-value {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-top: 4px;
}

.field-value--list {
  font-weight: 500;
}

.subcard {
  border-radius: 6px;
}

.fragmento-selected-label {
  margin: 0 16px 10px;
  padding: 8px 10px;
  border: 1px solid #d5e3fb;
  border-radius: 6px;
  background-color: #f3f8ff;
  color: #1d4f91;
  font-size: 12px;
  font-weight: 600;
}

::v-deep .fragment-selected {
  background-color: #f4f7fb !important;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.subpasos-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.subpaso-item {
  white-space: normal;
  line-height: 1.25;
}
</style>
